import PersonaCard from '@/components/Persona/PersonaCard';
import { getPersonaSlug, Persona } from '@/resources/personas/persona';
import Personas from '@/resources/personas/personas';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

export const PersonaPageList: FC<{
	isWide?: boolean;
	personas?: Persona[];
}> = ({ isWide, personas: overridePersonas }) => {
	return (
		<ul
			className={twMerge(
				'grid place-items-stretch gap-2 font-bold md:grid-cols-2',
				isWide && 'lg:grid-cols-3',
			)}>
			{(overridePersonas ?? Personas).map((persona) => (
				<li
					key={getPersonaSlug(persona)}
					className={twMerge(
						persona.disabilities.length > 1 && 'md:col-span-2',
					)}>
					<PersonaCard persona={persona} headingLevel="h2" />
				</li>
			))}
		</ul>
	);
};
